// for production
// enum RequestStatus {
// 	idle = 1,
// 	pending = 2,
// 	succes = 3,
// 	error = 4
// }

// For more readability in development
enum RequestStatus {
	idle = 'idle',
	pending = 'pending',
	succes = 'succes',
	error = 'error'
}

export default RequestStatus;